class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', 'false');
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.summary = this.mainDetailsToggle.querySelector('summary');
    requestAnimationFrame(() => this.packMegaMenuMasonry());
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (this.summary) {
      this.summary.setAttribute('aria-expanded', this.mainDetailsToggle.open ? 'true' : 'false');
    }

    if (this.mainDetailsToggle.open) {
      requestAnimationFrame(() => this.packMegaMenuMasonry());
    }

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }

  /**
   * Packs any number of childlinks into N columns by real height.
   * Column wrappers are presentational so listitem semantics stay intact for AT.
   */
  packMegaMenuMasonry() {
    const list = this.querySelector('[data-mega-menu-masonry]');
    if (!list || list.hasAttribute('data-mega-menu-packed')) return;

    const columnCount = Number(list.dataset.megaMenuColumns) || 6;
    const items = Array.from(list.querySelectorAll(':scope > .mega-menu__item'));
    if (!items.length) return;

    const styles = window.getComputedStyle(list);
    const rowGap = parseFloat(styles.rowGap) || 0;

    const measured = items.map((item) => ({
      item,
      height: item.getBoundingClientRect().height,
    }));

    if (measured.every(({ height }) => height === 0)) return;

    const columns = Array.from({ length: columnCount }, () => {
      const column = document.createElement('div');
      column.className = 'mega-menu__column';
      // Keep screen-reader list flat: columns are layout-only.
      column.setAttribute('role', 'presentation');
      return column;
    });
    const heights = new Array(columnCount).fill(0);

    measured.forEach(({ item, height }, index) => {
      let targetIndex = 0;

      if (index < columnCount) {
        targetIndex = index;
      } else {
        for (let i = 1; i < columnCount; i++) {
          if (heights[i] < heights[targetIndex]) targetIndex = i;
        }
      }

      if (!item.hasAttribute('role')) {
        item.setAttribute('role', 'listitem');
      }

      columns[targetIndex].appendChild(item);
      heights[targetIndex] += height + rowGap;
    });

    list.replaceChildren(...columns.filter((column) => column.childElementCount > 0));
    list.setAttribute('data-mega-menu-packed', '');
  }
}

customElements.define('header-menu', HeaderMenu);
